module.exports = __webpack_public_path__ + "static/heroslide-9-15a3da9301436bc6f2116306892a1505.jpeg";